import { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Authenticated from "./helper/authenticated";
import PrivateRoute from "./helper/private-route";
import { AppRoutes, AuthRoutes, DefaultRoute, PrivateRoutes } from "./routes";
import { Loader } from "@/components/ui/loader";
import { ScrollTop } from "@/lib/hooks/useScrollTop";

const AppRouter = () => {
  return (
    <>
      <Suspense
        fallback={
          <div className="w-screen h-screen bg-white">
            <Loader box big center />
          </div>
        }
      >
        <ScrollTop />
        <Routes>
          {Array.isArray(AppRoutes) &&
            AppRoutes?.length > 0 &&
            AppRoutes?.map((route, index) => {
              return (
                <Route
                  key={route.path + index}
                  path={route.path}
                  element={<route.component {...(route?.props ?? {})} />}
                />
              );
            })}

          {Array.isArray(AuthRoutes) &&
            AuthRoutes?.length > 0 &&
            AuthRoutes?.map((route, index) => {
              if (Object.keys(route)?.length === 0) {
                return null;
              }

              return (
                <Route element={<Authenticated />} key={route.path + index}>
                  <Route
                    path={route.path}
                    element={<route.component {...route.props} />}
                  />
                </Route>
              );
            })}

          {Array.isArray(PrivateRoutes) &&
            PrivateRoutes?.length > 0 &&
            PrivateRoutes?.map((route, index) => {
              if (Object.keys(route)?.length === 0) {
                return null;
              }

              return (
                <Route element={<PrivateRoute />} key={route.path + index}>
                  <Route
                    key={route.path + index}
                    path={route.path}
                    element={<route.component {...route.props} />}
                  />
                </Route>
              );
            })}

          {Array.isArray(AppRoutes) && AppRoutes?.length > 0 && (
            <Route path={DefaultRoute} element={<Navigate to="/" />} />
          )}
        </Routes>
      </Suspense>
    </>
  );
};

export default AppRouter;
